import React, { useEffect, useState } from "react";
import Input from "sushiweb/InputTypes/Input";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverCashTransactionsActions from "../../../store/actions/DriverCashTransactions";
import {
  isValidated as isValidatedForMandatoryFields,
  filterObj,
  addDays,
} from "../../../utils";
import styles from "../../../constants/assets/variables";
import { BottomSectionModal } from "../../../constants/assets/containers";
import Button from "sushiweb/Button";
import NoFooterModal from "../../Common/NoFooterModal";

const MAX_DAYS = 94;
const DAYS_IN_A_WEEK = 7;
const HOURS_IN_A_DAY = 24;
const SECONDS_IN_AN_HOUR = 3600;
const MILISECONDS_IN_A_SEC = 1000;


const toDateString = (date) => {
  return new Date(date.getTime() - date.getTimezoneOffset() * 60000)
    .toISOString()
    .split("T")[0];
};



const DriverCashTransactionsModal = (props) => {
  const {
    modalState,
    handleClose,
    activeFilters,
    filterFields,
    getDriverCashTransactionsList,
    resetCashTransactionStore,
  } = props;
  const [driverError, setDriverError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [startDateError, setStartDateError] = useState("");
  const [initialState, setInitialState] = useState({
    driver_id: "",
    start_date: toDateString(
      new Date(Date.now() - DAYS_IN_A_WEEK * HOURS_IN_A_DAY * SECONDS_IN_AN_HOUR * MILISECONDS_IN_A_SEC)
    ),
    end_date: toDateString(new Date(Date.now())),
  });
  const [currentDate, setCurrentDate] = useState();

  const isValidated = (body) => {
    let hasNoErrors = true;
    let validationState = isValidatedForMandatoryFields(body, ["driver_id"]);
    if (validationState !== "validated") {
      hasNoErrors = false;
      setDriverError(" Driver ID is mandatory");
    } else {
      setDriverError("");
    }

    let startDateValidationState = isValidatedForMandatoryFields(body, ["start_date"]);
    let endDateValidationState = isValidatedForMandatoryFields(body, ["end_date"]);

    if(startDateValidationState !== "validated"){
      hasNoErrors = false;
      setStartDateError("Start date is mandatory");
      setEndDateError("");
    } else {
      setStartDateError("");
    }

    if(endDateValidationState !== "validated"){
      hasNoErrors = false;
      setEndDateError("End date is mandatory");
    } else {
      setEndDateError("");
    }

    if (body["start_date"] && body["end_date"]) {
      let endDate = new Date(body["end_date"]);
      let startDate = new Date(body["start_date"]);
      if (startDate > endDate) {
        hasNoErrors = false;
        setEndDateError("End date should come after start date");
      } else {
        let maxPossibleDate = addDays(body["start_date"], 1 * MAX_DAYS);
        if (endDate > maxPossibleDate) {
          hasNoErrors = false;
          setEndDateError(
            "Maximum range of " +
              (MAX_DAYS + 1) +
              " days allowed, please modify dates"
          );
        } else {
          setEndDateError("");
          setStartDateError("");
        }
      }
    }
    return hasNoErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let body = filterObj(initialState, filterFields);
    if (!isValidated(body)) {
      return;
    }
    let filters = {};
    for (let key of filterFields) {
      if (body[key] !== "") {
        filters[key] = body[key] + "";
      }
    }

    getDriverCashTransactionsList(filters, {
      page: 1,
    }).then((_) => {
      handleClose();
    });
  };

  const handleClearFilters = () => {
    resetCashTransactionStore();
    handleClose();
  };

  const handleChange = (key, val) => {
    let values = { ...initialState };
    values[key] = val;
    setInitialState(values);
  };

  useEffect(() => {
    // set max date
    setCurrentDate(new Date().toISOString().substring(0, 10));
    //set the initial state of form in modal
    if (Object.keys(activeFilters).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((key, _) => {
        if (activeFilters[key]) {
          values[key] = activeFilters[key];
        }
      });
      setInitialState(values);
    }
  }, [activeFilters]);

  return (
    <NoFooterModal
      header
      heading="Cash Transactions Filter"
      handleClose={handleClearFilters}
      id="driverCashTransactionsFilterModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Button
            data-testid="drivercashtransactionsFormClearBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
          <Button
            data-testid="drivercashtransactionsFormSubmitBtn"
            onClick={handleSubmit}
            className="sushi-btn"
          >
            Apply
          </Button>
        </BottomSectionModal>
      }
    >
      <div>
        <Input
          value={initialState.driver_id}
          onChange={(e) => handleChange("driver_id", e)}
          id="sushi-input"
          inputProps={{
            "data-testid": "driverId",
          }}
          label="Driver ID"
          required={true}
          fullWidth={true}
          borderColor={styles.primaryColor}
          errorMsg={driverError}
          autoFocus={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          borderColor={styles.primaryColor}
          label="Start Date"
          type="date"
          value={initialState.start_date ? initialState.start_date : "  "}
          onChange={(e) => handleChange("start_date", e)}
          errorMsg={startDateError}
          fullWidth={true}
        />
        <Input
          max={currentDate}
          id="sushi-input"
          label="End Date"
          type="date"
          value={initialState.end_date ? initialState.end_date : "  "}
          onChange={(e) => handleChange("end_date", e)}
          fullWidth={true}
          errorMsg={endDateError}
          borderColor={styles.primaryColor}
        />
      </div>
    </NoFooterModal>
  );
};

function mapStateToProps(state) {
  const { DriverCashTransactions } = state;
  return {
    activeFilters: DriverCashTransactions.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    resetCashTransactionStore: () =>
      dispatch(DriverCashTransactionsActions.resetState({})),
    getDriverCashTransactionsList: bindActionCreators(
      DriverCashTransactionsActions.getDriverCashTransactionsList,
      dispatch
    ),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverCashTransactionsModal);
